// Shared ECharts theme built from CSS design tokens (styles/tokens.css).
// All chart colors resolve from tokens at render time — never hardcode colors.

const TOKEN_COLOR_VARS = {
  running: '--status-running',
  queued: '--status-queued',
  failed: '--status-failed',
  autonomous: '--status-autonomous',
  muted: '--text-secondary-ops'
};

const TOKEN_SURFACE_VARS = {
  raised: '--surface-raised',
  elevated: '--surface-elevated',
  border: '--border-ops',
  textPrimary: '--text-primary-ops',
  textSecondary: '--text-secondary-ops'
};

function readToken(name, fallback) {
  if (typeof document === 'undefined') {
    return fallback;
  }

  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return value || fallback;
}

export function resolveTokenColor(key) {
  const cssVar = TOKEN_COLOR_VARS[key] || TOKEN_COLOR_VARS.running;
  return readToken(cssVar, '#52e6a6');
}

export function buildChartTheme() {
  return {
    colors: Object.fromEntries(
      Object.keys(TOKEN_COLOR_VARS).map((key) => [key, resolveTokenColor(key)])
    ),
    surfaces: Object.fromEntries(
      Object.entries(TOKEN_SURFACE_VARS).map(([key, cssVar]) => [key, readToken(cssVar, '')])
    )
  };
}

export function buildBaseOption(theme) {
  return {
    grid: { left: 44, right: 16, top: 28, bottom: 28 },
    tooltip: {
      trigger: 'axis',
      backgroundColor: theme.surfaces.raised,
      borderColor: theme.surfaces.border,
      textStyle: { color: theme.surfaces.textPrimary, fontSize: 12 }
    },
    legend: {
      top: 0,
      right: 0,
      icon: 'circle',
      itemWidth: 8,
      itemHeight: 8,
      textStyle: { color: theme.surfaces.textSecondary, fontSize: 11 }
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      axisLine: { lineStyle: { color: theme.surfaces.border } },
      axisTick: { show: false },
      axisLabel: { color: theme.surfaces.textSecondary, fontSize: 11 },
      data: []
    },
    yAxis: {
      type: 'value',
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: { lineStyle: { color: theme.surfaces.border } },
      axisLabel: { color: theme.surfaces.textSecondary, fontSize: 11 }
    }
  };
}
